module.exports = __webpack_public_path__ + "img/美国.7b03cbd2.jpg";